import useRecordUserSession from '@/hooks/useRecordUserSession';

export default function RecordUserSession60Seconds() {
  useRecordUserSession();

  return null;
}
